<template>
  <div class="mb-4">
    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-auto" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">Customization Request Form</div>
              <table class="table  table-sm" border="1"
                     v-if="request_form !== null">
                <tr>
                  <td colspan="2" class="bg-gray-150">
                    FESC Leader
                  </td>
                  <td colspan="2" class="bg-gray-150">
                    Sales Leader
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="">
                    <div v-if="fesc_leader_approval !== null">
                      <!--<gtc-textarea :read-only="true" v-model="fesc_leader_approval.approval_comments" />-->
                      <div v-if="fesc_leader_approval !== null && fesc_leader_approval_comment_readonly === true" v-html="safeHtml(fesc_leader_approval.approval_comments)"></div>
                      <div v-else>
                      <gtc-textarea :read-only="fesc_leader_approval_comment_readonly"
                                    v-model="fesc_leader_approval.approval_comments" />
                      </div>
                    </div>
                    <div v-else>
                      <span>Null obj fesc_leader_approval </span>
                    </div>
                  </td>
                  <td colspan="2" class="">
                    <div v-if="sales_leader_approval !== null">
                      <!--<gtc-textarea :read-only="true" v-model="sales_leader_approval.approval_comments" />-->
                      <div v-if="sales_leader_approval_comment_readonly=== true" v-html="safeHtml(sales_leader_approval.approval_comments)"></div>
                      <div v-else> <gtc-textarea :read-only="sales_leader_approval_comment_readonly" v-model="sales_leader_approval.approval_comments" /></div>
                    </div>
                    <div v-else>
                      <span>Null obj sales_leader_approval </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="sales_leader_approval_comment_readonly === false || fesc_leader_approval_comment_readonly === false">
                  <td align="center" colspan="4" class="">
                    <div class="col-auto">
                      <button type="button" class="btn btn-primary" @click="request_form_approval_save('Agree')">Approve</button>
                      <button type="button" class="btn btn-danger" @click="request_form_approval_save('Reject')">Reject</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    ES Ticket ID/Request Form ID
                    <label style="color: red"> {{ request_form.ftie_id}} </label>/<label style="color: red"> {{ request_form.uni_id}}</label>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    1.Basic Information
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150" width="25%">
                    Business Center
                  </td>
                  <td width="25%">
                    <gtc-textarea :read-only="true" v-model="request_form.center" />
                  </td>
                  <td class="bg-gray-150" width="25%">
                    GRO
                  </td>
                  <td width="25%">
                    <gtc-textarea :read-only="true" v-model="request_form.gro" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Model
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.model" />
                  </td>
                  <td class="bg-gray-150">
                    Customer
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.company" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Apply Date
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.apply_date" />
                  </td>
                  <td class="bg-gray-150">
                    Vertical Market
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.vertical" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Applicant
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.applicant" />
                  </td>
                  <td class="bg-gray-150">
                    Opportunity Name
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.project" />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    2.Business Evaludation
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Quotation Quantity
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.qty" />
                  </td>
                  <td class="bg-gray-150">
                    Roll Out Schedule
                  </td>
                  <td>
                    <!--<gtc-textarea :read-only="false" v-model="roll_out_schedule" />-->
                    <input type="text" class="form-control" v-model="request_form.schedule" v-datepicker disabled />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Total Amount
                  </td>
                  <td>
                    <gtc-text-box :read-only="true" v-model="request_form.price" />
                  </td>
                  <td class="bg-gray-150">
                    Qualified Customer?
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="request_form.qualified" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Strategic Consideration
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.strategic" />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    3.Customization Requirement
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150" width="25%">
                    Hardware Modification
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.hardware_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Software Modification
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.software_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Mechincal Modification
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.me_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Application
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.application" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Safety/Regulation
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.safety" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Special Test Procedure and manufacturung requirement
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.special" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Others
                  </td>
                  <td colspan="3">
                    <gtc-textarea :read-only="true" v-model="request_form.others" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Related Document:
                  </td>
                  <td colspan="3">
                    <ul>
                      <li v-for="upload_file in filter_equest_form_ref_files" v-if="request_form!=null && request_form.ref_upload_files!=null"><a class="link"  @click="downloadAttachment(upload_file.file_name,  upload_file.old_file_name )" >{{ upload_file.old_file_name }}</a> </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td>
                    ES TL Comments:
                  </td>
                  <td>
                    <b-form-select v-if="fesc_tl_approval != null && fesc_tl_approval_comment_readonly === false" :options="tl_comments_option" label="ES TL Comments:" @change="setFescTlComment" v-model="fesc_tl_comment_select"></b-form-select>
                    <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">{{ fesc_tl_comment_select }}</div>
                  </td>
                  <td>
                    Expected completion date:
                  </td>
                  <td>
                    <input v-if="fesc_tl_approval != null && fesc_tl_approval_comment_readonly === false" type="text" class="form-control" v-model="fesc_tl_approval.target_date" v-datepicker />
                    <div v-else class="bg-gray-150 form-control form-control-sm min-w-7 max-w-7">{{ fesc_tl_approval.target_date | dateFormat }}</div>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    <div v-if="fesc_tl_approval !== null">
                      <!--<gtc-textarea :read-only="true" v-model="fesc_tl_approval.approval_comments" />-->
                      <div v-if="fesc_tl_approval_comment_readonly === true"
                           v-html="safeHtml(fesc_tl_approval.approval_comments)"></div>
                      <div v-else>
                        <gtc-textarea :read-only="fesc_tl_approval_comment_readonly"
                                      v-model="fesc_tl_approval.approval_comments" />
                      </div>
                    </div>
                    <div v-else>
                      <span>Null obj fesc_tl_approval  </span>
                    </div>
                  </td>
                </tr>
                <tr v-if="fesc_tl_approval_comment_readonly === false || fesc_tl_already_submit  === true">
                  <td align="center" colspan="4" class="">
                    <div class="col-auto">
                      <button  v-if="fesc_tl_already_submit === false" type="button" class="btn btn-primary" @click="request_form_approval_save('Agree')">Confirm Save</button>
                      <button  v-if="fesc_tl_already_submit === false" type="button" class="btn btn-danger" @click="request_form_approval_save('Reject')">Reject</button>
                      <button  v-if="fesc_tl_already_submit === true" type="button" class="btn btn-danger" @click="redirectToAssignRdFunction()">Assign RD Function</button>
                    </div>
                  </td>
                </tr>
              </table>

            </div>
            <!--#endregion-->
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'request-form-approval',
    data() {
      return {
        function_name: 'Customization Request Form',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        request_form: null,
        request_form_approvals: null,
        tl_comments_option: [
          'Goto Kickoff directly.',
          'Need Feasibility check meeting with PM',
          'Create PN/BOM directly.',
          'Feasibility check directly.',
          'Other Comments'
        ],
        fesc_tl_comment_select: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
      }
    },
    created() {
      let self = this;
      self.getRequestFormApprovals();
    },
    mounted() {
    },
    computed: {
      fesc_leader_approval() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("FESC Leader", item.approval_function); });
        return approval[0];
      },
      fesc_leader_approval_comment_readonly() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("FESC Leader", item.approval_function); });
        if (approval.length != 0 && self.$store.state.username == approval[0].approval_boss && approval[0].approval_status == 'Waiting') {
          return false;
        } else {
          return true;
        }
      },
      sales_leader_approval() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("Sales Leader", item.approval_function); });
        return approval[0];
      },
      sales_leader_approval_comment_readonly() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("Sales Leader", item.approval_function); });
        if (approval.length != 0 && self.$store.state.username == approval[0].approval_boss && approval[0].approval_status == 'Waiting') {
          return false;
        } else {
          return true;
        }
      },
      fesc_tl_approval() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("FESC TL", item.approval_function); });
        return approval[0];
      },
      fesc_tl_approval_comment_readonly() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("FESC TL", item.approval_function); });
        if (approval.length != 0 && self.$store.state.username == approval[0].approval_boss && approval[0].approval_status == 'Waiting') {
          return false;
        } else {
          return true;
        }
      },
      fesc_tl_already_submit() {
        let self = this;
        let approval = _.filter(self.request_form_approvals, item => { return _.includes("FESC TL", item.approval_function); });
        if (approval.length != 0 && self.$store.state.username == approval[0].approval_boss && approval[0].approval_status == 'Agree' ) {
          return true;
        } else {
          return false;
        }
      },
      filter_equest_form_ref_files() {
        let self = this;
        let filter_files = [];
        if (self.request_form != null && self.request_form.ref_upload_files != null && self.request_form.ref_upload_files != []) {
          filter_files = _.filter(self.request_form.ref_upload_files, item => { return moment(item.create_date).isAfter(self.request_form.create_date) && (moment(item.create_date).isBefore(self.request_form.apply_date) || self.request_form.apply_date == null); });
          return filter_files;
        } else {
          return filter_files;
        }
      }

    },
    methods: {
      getRequestFormApprovals() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/request-form-approval/';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          request_form_id: self.$route.params.request_form_id
        };
        let request_form = {};
        let request_form_approvals = [];
        eventHub.$emit('loading', true);

        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              request_form = JSON.parse(res['request_form']);
              request_form_approvals = JSON.parse(res['request_form_approvals']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.request_form = request_form;
            self.request_form_approvals = request_form_approvals;
            self.$forceUpdate();
            eventHub.$emit('loading', false);
          })
      },
      request_form_approval_save(action) {
        let self = this;
        let save_approval = null;
        if (self.fesc_leader_approval_comment_readonly===false) {
          save_approval = self.fesc_leader_approval;
        }
        else if (self.sales_leader_approval_comment_readonly === false) {
          save_approval = self.sales_leader_approval;
        }
        else if (self.fesc_tl_approval_comment_readonly === false) {
          save_approval = self.fesc_tl_approval;
        }
        save_approval.approval_status = action;
        if (save_approval.approval_comments === null || save_approval.approval_comments === '') {
          save_approval.approval_comments = action;
        }
        let url = self.$root.baseUrl + '/ftie/request-form-approval/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, save_approval, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
            eventHub.$emit('loading', false);
          })
          .finally(() => {
            self.$forceUpdate();
            eventHub.$emit('loading', false);
          })
      },
      setFescTlComment(fesc_tl_comment_select) {
        let self = this;
        self.fesc_tl_approval.approval_comments = fesc_tl_comment_select;
      },
      redirectToAssignRdFunction() {
        let self = this;
        window.location = this.frontEndUrlToUse + 'ftie/assign-rd-function' + '/' + encodeURIComponent(self.request_form.ftie_id) + '/' + encodeURIComponent(self.request_form.uni_id);
      },
      downloadAttachment(file_name, origin_file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/upload_file/' + file_name;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          origin_file_name: origin_file_name
        };
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params, responseType: 'arraybuffer' })
          .then((response) => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              console.log("file_name =" + origin_file_name);
              link.setAttribute('download', origin_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (response.status === 401) {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/_RequestFormApproval.vue